/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import ItemTitle from '../ItemTitle';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';

export default class Textarea extends React.Component {
  constructor(props) {
    super(props);
    [
      'valueDidChange',
      'blurAction'
    ].forEach((fn) => this[fn] = this[fn].bind(this));

    this.setupData(props)
  }

  valueDidChange = (event) => {
    /*
    * callback the onChange action.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const val = event.target.value;
    const { handleChange, content } = this.props;
    handleChange && handleChange(content.questionRel, val, event);

    return false;
  };

  blurAction = (event)=> {
    /*
    * callback the onBlur action.
    */

    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const val = event.target.value;
    const { handleBlurAction, content } = this.props;
    handleBlurAction && handleBlurAction(content.questionRel, val, event);

    return false;
  };

  setupData(props) {
    /*
    * setup component required props.
    */

    const {
      content
    } = props;

    this.titleObj = {
      questionMark: content.questionMark,
      question: content.question,
      questionTip: content.questionTip,
      controlFor: content.questionRel && content.questionRel.questionId && content.questionRel.questionId
    };
    this.isRequired = content.questionRel && !!content.questionRel.condition ? !!JSON.parse(content.questionRel.condition).mandatory : false;
    this.controlId = content.questionRel && content.questionRel.questionId && content.questionRel.questionId
  }

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }

  render() {
    const { content } = this.props;

    return (
      <div className="textarea">
        { content && content.question &&
        <ItemTitle content={ this.titleObj } isNeedLabel={ true } />
        }
        <FormGroup controlId={ this.controlId } validationState={ content.isError ? 'error' : null }>
          <FormControl
            componentClass="textarea"
            disabled={ content.isDisabled }
            value={ content.value || '' }
            placeholder={ content.placeholder }
            rows={ content.rows }
            data-key={ content.dataKey }
            onChange={ this.valueDidChange }
            onBlur={ this.blurAction }
            aria-required={ this.isRequired }
            aria-disabled={ content.isDisabled }
            aria-invalid={ content.isError }
            aria-describedby={`${this.controlId}-err`}
          />
          <HelpBlock id = {`${this.controlId}-err`}>{ content.errorMessage }</HelpBlock>
        </FormGroup>
      </div>
    )
  }
}

Textarea.propTypes = {
  content: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
  handleBlurAction: PropTypes.func,
};

Textarea.defaultProps = {
  content: {},
  isDisabled: false,
  isError: false
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/Textarea/index.js